import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'ttag';

import './ProductLabels.scss';

function ProductLabels({
  labels,
  discountPercentage,
  splash,
  isProductPage,
  extraClasses
}) {
  const isRomanianSite =
    typeof window !== 'undefined' && window.config?.pageMarket === 'ro';

  let labelList;

  if (isProductPage) {
    if (labels.length > 2 || (labels.length > 1 && splash)) {
      labelList = labels.slice(0, 2);
    } else {
      labelList = labels.slice(0, 3);
    }
  } else if (labels.length > 2 || (labels.length > 1 && splash)) {
    labelList = labels.slice(0, 1);
  } else {
    labelList = labels.slice(0, 2);
  }

  const BFCondition = window.config ? window.config.black_friday_ff : false;
  const isLabelRight = BFCondition && 'right';

  return (
    <div
      className={`label-container ${
        isProductPage ? 'product-page' : ''
      } ${isLabelRight}`}
    >
      {splash}
      {labelList.map(label => {
        if (label.discount && discountPercentage >= 10) {
          return (
            <React.Fragment key={label.name}>
              <div className={`splash ${extraClasses}`}>
                {isRomanianSite ? t`DEAL` : label.name}
              </div>
            </React.Fragment>
          );
        }
        if (!label.discount) {
          return (
            <React.Fragment key={label.name}>
              <div
                className="product-label"
                style={{
                  color: label.color,
                  background: label.background_color
                }}
              >
                {label.name}
              </div>
            </React.Fragment>
          );
        }
        return null;
      })}
    </div>
  );
}

ProductLabels.propTypes = {
  /**
   * Array of Labels
   */
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      background_color: PropTypes.string,
      color: PropTypes.string,
      discount: PropTypes.bool,
      name: PropTypes.string
    })
  ),
  /**
   * Discount Percentage
   */
  discountPercentage: PropTypes.number,
  /**
   * Splash
   */
  splash: PropTypes.node,
  /**
   * Is Product Page
   */
  isProductPage: PropTypes.bool.isRequired,
  /**
   * Extra Classes
   */
  extraClasses: PropTypes.string
};

ProductLabels.defaultProps = {
  labels: [],
  discountPercentage: 0,
  splash: null,
  extraClasses: ''
};

export default ProductLabels;
